import { ButtonBase } from '@mui/material';
import { Checkbox, Input, Select } from 'antd';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import countryCode from '../../config/countryCode.json';
const ContactCard = (props) => {
  const { viewMode } = props;
  const { watch, setValue, getValues, control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'contacts',
  });
  const handlePrimaryChange = (idx) => {
    const contacts = getValues('contacts');
    contacts.forEach((item, index) => {
      if (index === idx) {
        setValue(`contacts.${idx}.isPrimary`, true);
      } else {
        setValue(`contacts.${index}.isPrimary`, false);
      }
    });
  };
  const handleAddContact = () => {
    append({
      name: '',
      designation: '',
      countryCode: '',
      phoneNumber: '',
      email: '',
      smsNotification: 0,
      emailNotification: 0,
      isPrimary: 0,
    });
    console.log(getValues());
  };
  const handleRemoveContact = (index) => {
    remove(index);
    console.log(getValues());
  };
  return (
    <>
      {fields.map((item, index) => {
        const isPrimary = watch(`contacts.${index}.isPrimary`);
        return (
          <div className='mt-3 bg-[#f5f5f5] px-4 py-4' key={item.id}>
            <div className='flex items-center justify-between mb-[20px]'>
              <h4 className='text-[14px] text-[#1a202c] font-[600] flex items-center'>
                Point of contact {index + 1}
                {!isPrimary && (
                  <span
                    className='cursor-pointer bg-red-200 w-5 h-5 rounded-2xl flex items-center justify-center cursor-pointer ml-[13px]'
                    onClick={() => handleRemoveContact(index)}
                  >
                    <img
                      src='/images/cntDel.svg'
                      className='w-3 h-3'
                      alt='del'
                    />
                  </span>
                )}
              </h4>
              <label
                htmlFor={`prim${index}`}
                className='flex items-center select-none'
              >
                <Controller
                  control={control}
                  name={`contacts.${index}.isPrimary`}
                  render={({ field }) => {
                    return (
                      <Checkbox
                        {...field}
                        checked={field.value}
                        id={`prim${index}`}
                        disabled={viewMode}
                        onChange={() => handlePrimaryChange(index)}
                      />
                    );
                  }}
                />
                <span className='ml-[8px] cursor-pointer text-[13px]'>
                  Set as Primary
                </span>
              </label>
            </div>
            <div className='grid grid-cols-2 gap-x-3 gap-y-1 md:gap-y-4'>
              <div className='mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full'>
                <label className='block mb-[4px] text-[13px] text-[#798188]'>
                  Name
                </label>
                <Controller
                  control={control}
                  name={`contacts.${index}.name`}
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <Input
                        {...field}
                        status={fieldState.error ? 'error' : null}
                        placeholder='Name'
                        className='text-input'
                        disabled={viewMode}
                      />
                    );
                  }}
                />
              </div>
              <div className='mb-[30px] flex-[1] max-[600px]:flex-[unset] max-[600px]:w-full'>
                <label className='block mb-[4px] text-[13px] text-[#798188]'>
                  Designation
                </label>
                <Controller
                  control={control}
                  name={`contacts.${index}.designation`}
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <Input
                        {...field}
                        status={fieldState.error ? 'error' : null}
                        placeholder='Designation'
                        className='text-input'
                        disabled={viewMode}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className='grid grid-cols-2 gap-x-3 gap-y-1 md:gap-y-4'>
              <div className='col-span-2 md:col-span-1 gap-x-2 pb-5'>
                <div className='grid grid-cols-5 justify-between gap-x-3'>
                  <div className='col-span-2 md:col-span-2'>
                    <label className='block mb-[4px] text-[13px] text-[#798188]'>
                      Country Code*
                    </label>
                    <Controller
                      control={control}
                      name={`contacts.${index}.countryCode`}
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <Select
                            {...field}
                            showSearch
                            status={fieldState.error ? 'error' : null}
                            disabled={viewMode}
                            suffixIcon={
                              <img
                                src='/images/select_ar.svg'
                                alt='arrow'
                                className='mr-[2px]'
                              />
                            }
                            className='w-full'
                          >
                            {countryCode.map((item, idx) => {
                              return (
                                <Select.Option key={idx} value={item.dial_code}>
                                  {item.dial_code}
                                </Select.Option>
                              );
                            })}
                          </Select>
                        );
                      }}
                    />
                  </div>
                  <div className='col-span-3'>
                    <label className='block mb-[4px] text-[13px] text-[#798188]'>
                      Contact Number
                    </label>
                    <Controller
                      control={control}
                      name={`contacts.${index}.phoneNumber`}
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <Input
                            {...field}
                            maxLength={8}
                            status={fieldState.error ? 'error' : null}
                            placeholder='Contact Number'
                            className='text-input'
                            disabled={viewMode}
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className='col-span-2 md:col-span-1 pb-5'>
                <label className='block mb-[4px] text-[13px] text-[#798188]'>
                  Email address
                </label>
                <Controller
                  control={control}
                  name={`contacts.${index}.email`}
                  rules={{
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: '*Invalid Email',
                    },
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <Input
                        {...field}
                        status={fieldState.error ? 'error' : null}
                        placeholder='Enter Email'
                        className='text-input'
                        disabled={viewMode}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className='flex items-center gap-[10px] max-[600px]:flex-wrap'>
              <label
                htmlFor={`cn${index}`}
                className='flex items-start max-[600px]:w-full'
              >
                <Controller
                  control={control}
                  name={`contacts.${index}.smsNotification`}
                  render={({ field }) => {
                    return (
                      <Checkbox
                        {...field}
                        checked={field.value}
                        id={`cn${index}`}
                        disabled={viewMode}
                      />
                    );
                  }}
                />
                <span className='ml-[10px] font-[500] cursor-pointer text-[12px]'>
                  I would like to receive the latest update via SMS
                </span>
              </label>
              <label
                htmlFor={`cnt${index}`}
                className='flex items-start max-[600px]:w-full'
              >
                <Controller
                  control={control}
                  name={`contacts.${index}.emailNotification`}
                  render={({ field }) => {
                    return (
                      <Checkbox
                        {...field}
                        checked={field.value}
                        id={`cnt${index}`}
                        disabled={viewMode}
                      />
                    );
                  }}
                />
                <span className='ml-[10px] font-[500] cursor-pointer text-[12px]'>
                  I would like to receive the latest update via email
                </span>
              </label>
            </div>
          </div>
        );
      })}
      {!viewMode && (
        <ButtonBase
          className='mt-[20px!important] addContactBtn'
          disabled={fields.length >= 10}
          onClick={handleAddContact}
        >
          <div className='inline-block cursor-pointer p-[12px_16px] bg-gray-100  font-medium text-gray-600 text-[13px] border border-gray-200 rounded-[4px]'>
            Add Another Point of Contact (Max 10)
          </div>
        </ButtonBase>
      )}
    </>
  );
};

export default ContactCard;
